import React, { useState } from 'react'
import "./styles.css";
import { CallOwner, PhoneIcon } from "../../../Assets/images/svgs";
import { FloatingLabelTextInput } from "../components/index.";
import { isValidMobile } from '../../../Library/validations';
import CustomPopUpModal from '../../../Components/Atoms/CustomPopUpModal';
import { CS_IVR_NUMBER } from '../../../Library/constants';
import { contactOwner } from '../../../APIs';
import { useLocation } from 'react-router-dom';
import { logFirebaseEvent } from '../../../firebase/logEventHelper';

const CallVehOwner = () => {
  const location = useLocation();
  const [ contactNo, setContactNo ] = useState("");
  const [ errMsg, setErrMsg ] = useState("");
  const [ modalprops, setModalProps ] = useState(null);
  const [ loading, setLoading ] = useState(false);

  const handleTextInput = (e) => {
    setErrMsg("");
    setContactNo(e.target.value);
  }

  const resetStates = () => {
    setContactNo("");
    setErrMsg("");
    setModalProps(null);
  }

  const handleSubmit = () => {
    if (!contactNo) return;
    if (!isValidMobile(contactNo)) return setErrMsg("Please enter a valid mobile number!!");

    const handleCallNow = () => {
      logFirebaseEvent("CS_CALL_VEH_OWNER_NOW");
      resetStates();
      window.location.href = `tel:0${CS_IVR_NUMBER}`;
    }

    const payload = { ...location.state, mob: contactNo };
    setLoading(true);
    contactOwner(payload, (err) => {
      if (err) {
        console.error(err);
        setErrMsg("Error connecting to vehicle owner. Please try again later.");
      }
      else {
        setModalProps({
          open: true,
          onModalClose: () => setModalProps(null),
          contentClassName: "co-modal-content",
          bodyClassName: "co-modal-body",
          showCrossBtn: true,
          modalBody: (
            <div className='co-call-now-modal'>
              <span className='co-call-inf'>We’ve setup a call between you and vehicle owner. Please use the number you mentioned in the previous step to call them.</span>
              <div className="co-btn-cnt">
                <button className={`cs-btn-gradient cn-btn co-modal-btn`} onClick={handleCallNow}><PhoneIcon /> Call Now @ {CS_IVR_NUMBER}</button>
                <span className='cs-btn-label'>Be polite & humble while talking to vehicle owner</span>
              </div>
            </div>
          )
        });
      }
      setLoading(false);
    });
  }

  return (
    <div className='co-cnt'>
      <div className='co-body'>
        <CallOwner />
        <span className='co-note'>Please enter your valid contact number using which you want to call vehicle owner to set up a masked call</span>
        <FloatingLabelTextInput className="floating-input" type='number' label={"Your contact number"} required={true} value={contactNo} onChange={handleTextInput}/>
        {errMsg && <span className='co-err-msg'>{errMsg}</span>}
      </div>
      <button className={`cs-btn-gradient cn-btn ${!contactNo && 'disbale-btn'}`} onClick={handleSubmit}><PhoneIcon /> {loading ? "Coordinating a call with the vehicle owner." : "Submit"}</button>
      <CustomPopUpModal {...modalprops}/>
    </div>
  )
}

export default CallVehOwner;